import React, { Component } from 'react';
import { useState, useEffect } from "react";
import Modal from './Modal';
import check from "../../assets/check.svg";
import equis from "../../assets/eliminar.svg"
import ComponenteContrasenia from './ComponenteContrasenia';
import '../../css/FormAcuerdoAlumni.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import Header from './Header.js'
import Footer from './Footer.js'
import anuncioico from "../../assets/AnuncioICO.svg";
import jwt from 'jwt-decode'
import { Spinner } from 'react-bootstrap';
import Acuerdo from './Acuerdo.js'
import cerrar from "../../assets/cerrarSesion.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCheckCircle, faTimesCircle, faCheck } from "@fortawesome/free-solid-svg-icons";
import { limpiarSessionStorage } from "../../utils/session";
import MenuUsuario from './MenuUsuario';


export class FormAcuerdoAlumni extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPersonalData: false,
            errorsDatosEcu: {
            },
            expresiones: {
                cedula: /^[\d]{10}$/,
                pasaporte: /^[a-zA-Z0-9._]{4,14}$/,
            },
            verificarDatosEcu: {
                cedula: "",
                fechaEmision: "",
                terminos: ""
            },
            activebutton: true,
            modalIngresoDatos:false,
            modalErrorAcuerdoGen: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: equis,
            },
            aceptoAcuerdo: false,
            modalPrevAcuerdoGen: false,
            enlaceAcuerdo: "",
            modalIsOpen: false,
            verBoton: true,
            datosUsuario: {
                token: "",
                id: "",
                identificacion: "0",
                alias_sugerido: "",
                telefono: "",
                unidad: "",
                rol: "",
                correoAlterno: "",
                nombres: "",
                apellidos: "",
                username: "",
                correo: "",
                usuarioEscogido: "",
                fechaNacimiento:""
            },
            idAcueFirmElec:"",
            contra: {
                contrasena: "",
                contrasenaCumple: false,
                repetirContraCumple: false,
            },
            navigateCas: true,
            modalError: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },
            IsSign: false,
        };
        this.handlerOnBlurCedula = this.handlerOnBlurCedula.bind(this);
        this.abrirModalInfo = this.abrirModalInfo.bind(this);
        this.cerrarModalInfo = this.cerrarModalInfo.bind(this);
        this.cerrarModalIngresoDatos = this.cerrarModalIngresoDatos.bind(this);
        this.abrirModalIngresoDatos = this.abrirModalIngresoDatos.bind(this);
        this.cerrarModalErrorGen = this.cerrarModalErrorGen.bind(this);
        this.cerrarModalPrevGen = this.cerrarModalPrevGen.bind(this);
        this.abrirModalPrevGen = this.abrirModalPrevGen.bind(this);
        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);

    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });
    }

    componentWillMount = () => {
        limpiarSessionStorage();
    
        let queryString = document.referrer;
        if (queryString != "" && queryString != null && queryString != undefined)
            localStorage.setItem('servicio', queryString);
    }

    cerrarModalErrorGen() {
        this.setState({
            modalErrorAcuerdoGen: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        }, () => {
            this.activebuttonf();
        });
    }

    cerrarModalPrevGen() {
        this.setState({
            modalPrevAcuerdoGen: false,
        });
    }

    abrirModalPrevGen() {
        this.setState({
            modalPrevAcuerdoGen: true,
        });
    }

    abrirModalIngresoDatos() {
        this.setState({ modalIngresoDatos: true })
    }

    cerrarModalIngresoDatos() {
        if (!this.state.isPersonalData || !this.state.modalPrevAcuerdoGen) {
            var servicio = localStorage.getItem('servicio');
            if (servicio != null || servicio != undefined) {
                //window.location.href = 'https://alumni.espol.edu.ec/';
                window.location.href = servicio;
            } else {
                window.location.href = 'https://alumni.espol.edu.ec/';
            }
        }
    }

    abrirModalError() {
        this.setState({
            modalError: {
                ...this.state.modalError,
                show: true
            }
        });
    }


    cerrarModalError() {
        this.setState({
            modalError: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalError);
    }

    abrirModalInfo() {
        this.setState({ modalIsOpen: true });
    }

    cerrarModalInfo() {
        this.setState({ modalIsOpen: false });
        this.activarNavigateLogin();
    }

    activarNavigateLogin() {
        window.location.href = "/Inicio";
    }


    getCedulaByUsername = async (e) => {
        var username = this.state.datosUsuario.username;
        if (username != "") {
            await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario/getcedulauser/${username}`)
                .then(r => {
                    //console.log(JSON.stringify(r));
                    if (r.status == 200) {
                        // console.log(r.data.persona.identificacion);
                        //this.state.datosUsuario.identificacion=r.data.persona.identificacion;
                        this.setState({
                            datosUsuario: {
                                ...this.state.datosUsuario,
                                identificacion: r.data.persona.identificacion,
                            }
                        }, () => {
                            this.setState({ navigateCas: false });
                            //console.log("validar cas: "+this.state.datosUsuario.identificacion);
                            if (this.state.datosUsuario.identificacion != 0) {
                                //console.log("validar firma para mostrar el acuerdo: ", this.state.datosUsuario.identificacion);
                                this.validarFirmaAcuerdo();
                            }
                        })
                    }
                })
                .catch(error => {
                    //console.log(error.message);
                })
        }
    }

    cerrarSesion = async () => {
        Cookies.remove("token");
        Cookies.remove("cas");
        Cookies.remove("DatosPersonalesGIA.CAS");
        window.location.href = "/logout";
    }


    validarFirmaAcuerdo = async (e) => {
        var id_temp = this.state.datosUsuario.identificacion;
        if (id_temp != "") {
            await axios.get(`${process.env.REACT_APP_API}api/Persona/enlacefirmaacgen/${id_temp}`)
                .then(r => {
                    //console.log("validarFirmaAcuerdo");
                    //console.log(JSON.stringify(r));
                    if (r.status == 200) {
                        //console.log(r.data);
                        this.setState({
                            IsSign: true,
                            enlaceAcuerdo: r.data,
                        })
                    }
                })
                .catch(error => {
                    //console.log(error.message);
                })
        }
    }


    mostrarModalData = async (e) => {
        //this.setState({ modalData: false });
        //console.log("asdasd");
    }

    handlerOnBlurCedula = async (e) => {
        if (!this.state.expresiones.pasaporte.test(this.state.verificarDato)) {
            await this.setState({
                errorsDatosCed: {
                    cedula: "Identificacion debe tener 10 dígitos",
                }
            })
        } else {
            this.setState({ errorsDatosCed: {} })
        }
       
    }


    getVerificarDataAlumni = async (e) => {
        e.preventDefault();
        this.disabledbuttonf();
        //console.log(`${process.env.REACT_APP_API}api/Persona/firmarAcuerdoAlumni/${this.state.verificarDatosEcu.cedula}/${this.state.verificarDatosEcu.fechaEmision}`)
        await axios.get(`${process.env.REACT_APP_API}api/Persona/firmarAcuerdoAlumni/${this.state.verificarDatosEcu.cedula}/${this.state.verificarDatosEcu.fechaEmision}`)
            .then(r => {
                if (r.status == 200) {
               // console.log(r.data);
                this.setState({
                    datosUsuario: {
                        ...this.state.datosUsuario,
                        identificacion: r.data.persona.identificacion,
                        nombres: r.data.persona.nombres,
                        apellidos: r.data.persona.apellidos,
                        username: r.data.cuentaUsuario.username,
                    },
                    modalPrevAcuerdoGen: true,
                    isPersonalData: true,
                }, () => {
                    this.activebuttonf();
                    this.cerrarModalIngresoDatos();
                    sessionStorage.setItem("token_nueva_cuenta", r.data.token.token);
                });
               // console.log(this.state.datosUsuario);   
                }
            })
            .catch(error => {
                this.setState({
                    modalErrorAcuerdoGen: {
                        show: true,
                        titulo: "Firma del acuerdo de uso de datos personales y el acuerdo de uso de medios electrónicos - AlumniESPOL",
                        mensaje: error.response.data.errorMessage,
                        imagen: equis,
                    }
                });
               // console.log(error.response.data.errorMessage);
            })
    }

    handlerOnBlurEcu = async (e) => {

        if (!this.state.expresiones.cedula.test(this.state.verificarDatosEcu.cedula)) {
            await this.setState({
                errorsDatosEcu: {
                    cedula: "Identificacion debe tener 10 dígitos",
                }
            })
        } else {
            this.setState({ errorsDatosEcu: {} })
        }

    }


    verAcuerdoAlumni() {
        //console.log("ver acuerdo alumni");
    }

    handlerVerificarDatosEcu = async (e) => {


        await this.setState({
            verificarDatosEcu: {
                ...this.state.verificarDatosEcu,
                [e.target.name]: e.target.value,
                terminos: e.target.checked
            }      
        })

        this.handlerOnBlurEcu();
    }


    handlerDatosFormRegistro = async (e) => {
        await this.setState({
            aceptoAcuerdo: e.target.checked,
            
        })
    }

    render() {
        var nombresCompletos = `${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`
        var username = `${this.state.datosUsuario.username}`
        //console.log("----------------------------------");
        //console.log("navigateCas ", this.state.navigateCas);
        //console.log("IsSign ", this.state.IsSign);

        return (
            <>
                
                <Header />
                {!this.state.isPersonalData ?
                (
                    <div>
                        <Modal isOpen={this.state.modalIngresoDatos} cerrarModal={this.cerrarModalIngresoDatos} verBoton={false} >
                            <p className='text-center acuerdo-modalFME-titulo'><strong>VALIDACIÓN DE DATOS </strong></p>
                            <div className="acuerdoAlumni">
                                <form onSubmit={this.getVerificarDataAlumni}>
                                    <div className="nacionalidad-container-ecuext">
                                        <div className="row" >
                                            <div className="col-12 col-md-4 col-xl-4 mt-3 nacionalidad-lblinp-ecuext ">
                                                <label className="form-label" htmlFor="cedula">Número de la cédula</label>
                                            </div>
                                            <div className="col-12 col-md-8 col-xl-8 mt-3" >
                                                <input type="text" className={this.state.errorsDatosEcu.cedula ? "nacionalidad-input-error form-control" : "form-control"}
                                                    name="cedula" value={this.state.verificarDatosEcu.cedula}
                                                    onChange={this.handlerVerificarDatosEcu}
                                                    onBlur={this.handlerOnBlurEcu} />
                                                {this.state.errorsDatosEcu.cedula &&
                                                    <p className='nacionalidad-leyenda'>{this.state.errorsDatosEcu.cedula}</p>
                                                }
                                            </div>


                                            <div className="col-12 col-md-4 col-xl-4 mt-3 nacionalidad-lblinp-ecuext">
                                                <label className="form-label" htmlFor="fechaEmision">Fecha de nacimiento</label>
                                            </div>
                                            <div className="col-12 col-md-8 col-xl-8 mt-3" >
                                                <input type="date" className="form-control" name="fechaEmision" value={this.state.verificarDatosEcu.fechaEmision} onChange={this.handlerVerificarDatosEcu} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-xl-12 " align="center">
                                                <div>
                                                    <button

                                                        disabled={this.state.verificarDatosEcu.cedula &&
                                                            this.state.verificarDatosEcu.fechaEmision &&

                                                            this.state.activebutton &&
                                                            !this.state.errorsDatosEcu.cedula ? false : true}
                                                        type="submit"
                                                        className={this.state.verificarDatosEcu.cedula &&
                                                            this.state.verificarDatosEcu.fechaEmision &&

                                                            this.state.activebutton &&
                                                            !this.state.errorsDatosEcu.cedula ?
                                                            "nacionalidad-btn-verificar" : "nacionalidad-btn-verificar-disabled"}>VERIFICAR</button>
                                                    {!this.state.activebutton ?
                                                        <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                                        : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Modal>

                        {this.state.modalErrorAcuerdoGen.show &&
                            <Modal isOpen={this.state.modalErrorAcuerdoGen.show} cerrarModal={this.cerrarModalErrorGen} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalErrorAcuerdoGen.titulo}</strong></p>
                                <div align="center">
                                    <img className="registroContra-check" src={this.state.modalErrorAcuerdoGen.imagen} alt="Exitoso"></img>
                                </div>
                                <p className='text-center'>{this.state.modalErrorAcuerdoGen.mensaje}</p>
                            </Modal>
                        }
                       
                    </div>
                    
                )
                :
                (
                    <div>
                        <Acuerdo
                            identificacion={this.state.datosUsuario.identificacion}
                            nombres={this.state.datosUsuario.nombres}
                            apellidos={this.state.datosUsuario.apellidos}
                            alias_sugerido={this.state.datosUsuario.alias_sugerido}
                            usuario_sugerido={this.state.datosUsuario.username}
                            correoAlterno={this.state.datosUsuario.correoAlterno}
                            rol={this.state.datosUsuario.rol}
                            telefono={this.state.datosUsuario.telefono}
                            unidad={this.state.datosUsuario.unidad}
                            tipoForm={"A"}
                            mensaje_titulo="Firma de acuerdo"
                            verbtngeneral={true}
                            firmadoGeneral={true}
                            tipoAcuerdo={"ALUMNI"}
                            modalPrevAcuerdoGen={true}
                            /*useEffect={this.props.useEffect}*/
                        ></Acuerdo>
                        {/*
                        this.state.modalPrevAcuerdoGen &&
                            <Modal isOpen={this.state.modalPrevAcuerdoGen} cerrarModal={this.cerrarModalPrevGen} >
                                  
                            <h2 className='text-center'><strong>  Firma del acuerdo de uso de datos personales y el acuerdo de uso de medios electrónicos - AlumniESPOL</strong></h2>
                                    <p className='text-center'><input className="form-check-input"
                                        type="checkbox" name="usuarioEscogido"
                                        id="usuarioEscogido" value={"He leído el Acuerdo de uso de datos personales y Acuerdo de uso de medios electrónicos."}
                                        onClick={this.handlerDatosFormRegistro}
                                        />He leído el Acuerdo de uso de datos personales y Acuerdo de uso de medios electrónicos.</p>
                                    <p className='text-center'>Para leer el documento completo dar clic aquí.</p>
                            <div align="center">
                                <button onClick={this.verAcuerdoAlumni} className="input-group-text pb-6">
                                    Aceptar
                                </button>
                            </div>
                        </Modal>
                        */}
                    </div>
                )
            }
            </>
        )
    }
}

export default FormAcuerdoAlumni
